module.exports = "i {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/password/password.component.css
// module id = ./src/app/shared/password/password.component.css
// module chunks = main